export default {
  button: {
    margin: '1rem 2rem 0',
  },
  link: {
    cursor: 'pointer',
  },
  popup: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  heading: {
    padding: '0 2rem',
  },
  main: {
    maxHeight: '65vh',
    overflow: 'auto',
    padding: '0 2rem',

    '& ul': {
      marginBottom: '2rem',
    },
    '& ul:last-child': {
      marginBottom: 0,
    },
    '& li': {
      marginBottom: '0.5rem',
    },
  },
}
